export interface OrderStatus {
  code: string | number;
  label: string; // default label (in Spanish or English)
  translationKey: string;
  color: string;
  textColor: string;
}

export const ORDER_STATUS: Record<string, OrderStatus> = {
  '1': {
    code: '1',
    label: 'Open',
    translationKey: 'orders.status.open',
    color: '#899193',
    textColor: '#FFFFFF',
  },
  '2': {
    code: '2',
    label: 'In Process',
    translationKey: 'orders.status.inProcess',
    color: '#516FAE',
    textColor: '#FFFFFF',
  },
  '3': {
    code: '3',
    label: 'Completed',
    translationKey: 'orders.status.completed',
    color: '#C4DD6C',
    textColor: 'rgba(0, 0, 0, 0.87)',
  },
  '4': {
    code: '4',
    label: 'In Preparation',
    translationKey: 'orders.status.inPreparation',
    color: '#7A6041',
    textColor: '#FFFFFF',
  },
};

export const getOrderStatus = (code: string | number): OrderStatus | undefined => {
  return ORDER_STATUS[String(code)];
};

export const getOrderStatusOptions = () =>
  Object.values(ORDER_STATUS).map((status) => ({
    value: status.code,
    label: status.label,
  }));
